<!--企业详情-->
<template>
  <div class="enterprise-details-container">
    <header-index/>
    <div class="enterprise-details-content">
      <div class="enterprise-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>企业详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="enterprise-details-basic-content">
        <el-container>
          <el-aside width="170px">
            <el-image shape="square" fit="contain" style="width: 150px;height: 150px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                      draggable="false" :src="basicData.companyLogo" v-if="basicData.companyLogo!=null &&
                    basicData.companyLogo!='' && basicData.companyLogo!='None' &&
                    basicData.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    basicData.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    basicData.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    basicData.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
              <div slot="error" class="image-slot">
                <div class="logo-keyword" :style="'background:rgb(39, 64, 139);'" v-if="basicData.entLogoWord">
                  <span v-for="(logo,index) of logoWord(basicData.entLogoWord)" class="logo-word" v-if="index<4">{{ logo }}</span>
                </div>
                <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                  <span v-for="(b,index) of logoWord(basicData.companyName)" class="logo-word" v-if="index<4">{{b}}</span>
                </div>
              </div>
            </el-image>
            <el-avatar shape="square" fit="scale-down" v-else style="width: 150px;height: 150px">
              <div class="logo-keyword" :style="'background:rgb(39, 64, 139);'" v-if="basicData.entLogoWord">
                <span v-for="(logo,index) of logoWord(basicData.entLogoWord)" class="logo-word"v-if="index<4">{{ logo }}</span>
              </div>
              <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                <span v-for="(b,index) of logoWord(basicData.companyName)" class="logo-word" v-if="index<4">{{b}}</span>
              </div>
            </el-avatar>
          </el-aside>
          <el-main>
            <div class="userName">{{ basicData.companyName }}
              <span class="span-success" v-if="basicData.status=='开业' || basicData.status=='存续'">
                {{basicData.status}}
              </span>
              <span class="span-danger" v-else-if="!basicData.status">未知</span>
              <span class="span-danger" v-else>{{ basicData.status }}</span>
            </div>
            <i class="item-label" v-for="(items,index) of basicData.labels">{{ items }}</i>
            <el-row class="gray-div">
              <el-col :span="10"><span>法定代表人：</span><span>{{ basicData.name || '-' }}</span></el-col>
              <el-col :span="14"><span>统一社会信用代码：</span><span>{{ basicData.unifiedSocialCreditCode || '-'}}</span></el-col>
              <el-col :span="10" style="margin-top: 10px;">
                <span>电话：</span><span>{{ basicData.telephony }}</span>
              </el-col>
              <el-col :span="14" style="margin-top: 10px;"><span>官网：</span><el-link type="primary" :href="basicData.website" :underline="false">{{ basicData.website || '-' }}</el-link></el-col>
              <el-col :span="10" style="margin-top: 10px;"><span>邮箱：</span><span>{{ basicData.mailbox || '-' }}</span></el-col>
              <el-col :span="14" style="margin-top: 10px;"><span>地址：</span><span>{{ basicData.address==0 || !basicData.address || basicData.address=='0' ? '-' : basicData.address}}</span></el-col>
              <el-col :span="24" style="margin-top: 10px;">
                <span style="float:left;">简介：</span>
                <div :class="className">
                  <span>{{ basicData.synopsis || '-' }}</span>
                  <el-link type="primary" v-show="displayDom && textLength > 70" @click="hideBasic">收起<i class="el-icon-arrow-up"/></el-link>
                </div>
                <el-link type="primary" style="float: left;" v-show="!displayDom && textLength > 70" @click="showBasic">展开<i class="el-icon-arrow-down"/></el-link>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </div>
      <div :class="isMove ? 'enterprise-details-tabs fixed-tabs' : 'enterprise-details-tabs'">
        <el-tabs type="border-card" v-model="activeTabs" :stretch="true">
          <el-tab-pane v-for="tab of tabsList" :label="tab.label" :name="tab.name">
            <el-radio-group v-model="subTabs" @change="locationIndex">
              <el-radio-button v-for="(sub,index) of tab.sublist" :label="tab.name+index">{{sub}}</el-radio-button>
            </el-radio-group>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!--基本信息-->
      <div class="essentialInfo" v-if="activeTabs=='basic'">
        <essential-info ref="basic" :corpId="id"/>
      </div>
      <!--法律风险-->
      <div class="essentialInfo" v-if="activeTabs=='legal'">
        <legal-risks ref="legal" :corpId="id"/>
      </div>
      <!--经营风险-->
      <div class="essentialInfo" v-if="activeTabs=='business'">
        <operate-risks ref="business" :corpId="id"/>
      </div>
      <!--经营信息-->
      <div class="essentialInfo" v-if="activeTabs=='businessInfos'">
        <operate-info ref="businessInfos" :corpId="id"/>
      </div>
      <!--企业发展-->
      <div class="essentialInfo" v-if="activeTabs=='development'">
        <enterprise-development ref="development" :corpId="id"/>
      </div>
      <!--知识产权-->
      <div class="essentialInfo" v-if="activeTabs=='right'">
        <intellectual-property ref="right" :corpId="id"/>
      </div>
      <!--新闻公告-->
      <div class="essentialInfo" v-if="activeTabs=='announcement'">
        <popular-feelings ref="announcement" :corpId="id"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>

<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import {getCompanyInfo} from '@/api/enterpriseDetailsApi'
import EssentialInfo from "@/views/enterpriseDetails/essentialInfo";
import LegalRisks from "@/views/enterpriseDetails/legalRisks";
import OperateRisks from "@/views/enterpriseDetails/operateRisks";
import OperateInfo from "@/views/enterpriseDetails/operateInfo";
import EnterpriseDevelopment from "@/views/enterpriseDetails/enterpriseDevelopment";
import IntellectualProperty from "@/views/enterpriseDetails/intellectualProperty";
import PopularFeelings from "@/views/enterpriseDetails/popularFeelings";

export default {
  name: "index",
  components: {
    PopularFeelings,
    IntellectualProperty,
    EnterpriseDevelopment,
    OperateInfo, OperateRisks, LegalRisks, EssentialInfo, Hang, Home_footer, HeaderIndex},
  data() {
    return {
      cid: 0,
      cityList: {},
      id: 0,
      basicData: {},
      className: 'ellipsisBasic',
      /*显示隐藏*/
      displayDom: false,
      /*内容字数*/
      textLength: 0,
      activeTabs:'basic',
      tabsList:[
        {label:'基本信息',name:'basic',sublist:['工商信息', '股权穿透图', '股东信息', '主要人员', '对外投资', '最终受益人', '疑似实际控制人', '控股企业', '分支机构', '变更记录', '企业年报']},
        {label:'法律风险',name:'legal',sublist: ['法律诉讼', '开庭公告', '法院公告', '送达公告', '立案信息', '终本案件', '司法拍卖', '限制消费令', '失信信息', '被执行人', '司法协助', '询价评估', '司法解析']},
        {label:'经营风险',name:'business',sublist: ['经营异常', '行政处罚', '严重违法', '股权出质', '股权质押', '税收违法', '动产抵押', '环保处罚', '欠税公告', '清算信息', '知识产权出质', '公示催收', '土地抵押', '简易注销']},
        {label:'经营信息',name:'businessInfos',sublist: ['行政许可', '招投标', '进出口信用', '资质证书', '双随机抽查', '产品信息', '税务评级', '购地信息', '电信许可', '供应商', '客户', '地块公示', '财务解析', '土地转让', '公告研报', '抽查检查']},
        {label:'企业发展',name:'development',sublist: ['融资历程', '核心团队', '企业业务', '竞品信息', '投资机构', '私募基金']},
        {label:'知识产权',name:'right',sublist: ['专利信息', '商标信息', '作品著作权', '网站备案']},
        {label:'新闻公告',name:'announcement',sublist: ['新闻舆情']}
      ],
      subTabs:'',
      isMove:false,
    }
  },
  computed:{
    logoWord(){
      return function (word){
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  created() {
    this.listenerFunction();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    /*获取企业基本信息*/
    getEnterpriseDetailsInfo() {
      getCompanyInfo({request: 'form', id: this.id}).then(res => {
        if (res.code == 200) {
          this.basicData = res.content;
          if (res.content.synopsis != '' && res.content.synopsis != undefined && res.content.synopsis != null) {
            this.textLength = res.content.synopsis.length;
          }
        }
      })
    },
    /*随机生成颜色值*/
    createRandomColor() {
      let num=Math.floor(Math.random()*9+1);
      let colorList=['#7db3d9','#d1ae9d','#ca8484','#bc9edd','#8B658B','#B22222','#27408B','#008B8B','#5D478B','#68228B'];
      return colorList[num];
    },
    /*显示多余内容*/
    showBasic() {
      this.displayDom = true;
      this.className = 'briefIntroduce';
    },
    /*隐藏多余内容*/
    hideBasic() {
      this.displayDom = false;
      this.className = 'ellipsisBasic';
    },
    /*tabs标签切换*/
    locationIndex(value){
      this.$refs[this.activeTabs].scrollToArea(value)
    },
    /*监听滚动*/
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true);
    },
    /*当滚动超过300px固定tabs标签于顶部*/
    handleScroll() {
      if (window.pageYOffset > 50) {
        this.isMove = true;
      } else {
        this.isMove = false;
      }
    },
  },
  mounted() {
    this.getEnterpriseDetailsInfo();
  },
  beforeMount() {
    this.id = parseInt(this.$route.query.id);
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb__inner a,
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-basic-content .el-card__body,
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-basic-content .el-main {
  padding: 0px 0px 0px 20px;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-basic-content .el-link.el-link--primary {
  color: #1637FF;
  font-size: 16px;
  vertical-align: baseline;
}
.enterprise-details-container >>> .el-avatar > img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}
.enterprise-details-container >>> .el-avatar {
  background: white;
  border: 1px solid rgba(0, 0, 0, .05);
  border-radius: 4px;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
  color: #0067DD;
  border-top: 4px solid #0067DD;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #0067DD;
  background-color: #FFF;
  border-top: 4px solid #0067DD;
  font-family: 'SourceHanSansCN';
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-tabs--border-card > .el-tabs__header {
  background-color: #FFFFFF;
  border-bottom: none;
  margin: 0;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border: 1px solid #EEEEEE;
  color: #333333;
  font-size: 15px;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-tabs--border-card {
  background: #FFF;
  border: none;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-tabs__item {
  padding: 0 20px;
  height: 55px;
  line-height: 55px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #1637FF;
  background-color: #FFFFFF;
  border-color: #1637FF;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 4px;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-radio-button__inner {
  background: #FFF;
  border: 1px solid #DCDFE6;
  border-left: 1px solid #DCDFE6;
  color: #333333;
  border-radius: 4px;
  margin-right: 10px;
  padding: 12px 20px;
  font-size: 14px;
}
.enterprise-details-container >>> .enterprise-details-content .enterprise-details-tabs .el-radio-button {
  margin: 5px 0px;
}
</style>
<style scoped lang="scss">
.enterprise-details-container {
  background: #ECEEF5;
  .enterprise-details-content {
    padding: 10px 18%;
    min-width: 76rem;
    background: #ECEEF5;
    .enterprise-details-basic-content {
      background: #FFFFFF;
      padding: 30px;
      margin-top: 10px;
      .logo-keyword {
        height: 150px;
        width: 150px;
        font-size: 48px;
        color: #ffffff;
        font-weight: 500;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin: 0px;
        .logo-word {
          width: 34%;
          height: 34%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .userName {
        font-size: 35px;
        font-weight: bold;
        margin-bottom: 15px;
        .span-danger {
          font-size: 10pt;
          border: 1px solid #FE273B;
          padding: 10px 20px;
          color: #FE273B;
          position: absolute;
          margin-top: 7px;
          margin-left: 8.5pt;
          border-radius: 4pt;
          cursor: pointer;
        }
        .span-success {
          font-size: 10pt;
          border: 1px solid #1FC89F;
          padding: 10px 20px;
          color: #1FC89F;
          position: absolute;
          margin-top: 7px;
          margin-left: 8.5pt;
          border-radius: 4pt;
          cursor: pointer;
        }
      }
      .item-label {
        border: 1px solid #E1E5FF;
        padding: 10px 8px;
        color: #1637FF;
        background: #E1E5FF;
        font-style: normal;
        font-size: 14px;
        border-radius: 6px;
        margin-right: 10px;
        cursor: pointer;
        font-family: 'SourceHanSansCN';
      }
      .gray-div {
        background: #F5F5F5;
        padding: 20px;
        margin-top: 15px;
        font-size: 16px;
        .ellipsisBasic {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 89%;
          float: left;
        }
        .briefIntroduce {
          width: 92%;
          /** word-break: normal(使用浏览器默认的换行规则)|break-all(允许在西文单词中换行)|keep-all(只能在半角空格或连字符处换行);通过该属性规定自动换行的处理方法，即遵循何种方式换行。 */
          word-break: break-all;
          /** word-wrap: normal(只在允许默认的断字点处换行，浏览器默认)|break-word(在长单词或URL内部换行);通过该属性允许长单词或URL换行到下一行。 */
          word-wrap: break-word;
          /** 行高一般设置20-24px即可 */
          line-height: 24px;
          float: left;
        }
      }
    }
    .enterprise-details-tabs{
      margin-top: 10px;
      .item-basic {
        margin: auto 0px 10px 10px;
      }
    }
    .fixed-tabs{
      top: -10px;
      position: fixed;
      z-index: 9999;
      width: 64%;
    }
    .essentialInfo{
      margin-top: 10px;
    }
  }
}
</style>